<template>
  <div class="lmp-block clearBoth">
    <g-switch-list4
      :chip="chip"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :title="d.title"
      :columns="2"
      :current="current"
      :list="d.list" />
    <g-switch-list4
      :chip="chip"
      class="lmp-vertical"
      v-for="(d, i) in data.vertical"
      :key="'v' + i"
      :vertical-type="1"
      :current="current"
      :title="d.title"
      :columns="2"
      :list="d.list" />
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchList4 from '../../c_game-switch/switch-list/g_switch-4'; // 纵向

  export default {
    name: "texiaoshouwei",
    mixins: [mixin],
    components: {
      GSwitchList4
    }
  }
</script>

<style scoped lang="stylus">
  .lmp-vertical
    margin-top 7px

  .lmp-vertical + .lmp-vertical
    margin-left 7px

  .lmp-vertical:nth-of-type(6)
    margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/lh/texiaoshouwei.vue